import { KubesoloHostResult, KubesoloTest } from '@api/types.gen';

import { FormSection } from '@@/form-components/FormSection';

import { HostList } from './HostList';

interface Props {
  running: Array<KubesoloHostResult>;
  queued: Array<KubesoloHostResult>;
  test: KubesoloTest;
}

/** Folded by default: the progress bar already says the test is alive, this says what each machine is doing. */
export function InProgressSection({ running, queued, test }: Props) {
  if (running.length + queued.length === 0) {
    return null;
  }

  return (
    <FormSection
      id="kubesolo-test-in-progress"
      title={title(running.length, queued.length)}
      titleSize="sm"
      isFoldable
    >
      {running.length > 0 && (
        <HostList label="Running" hosts={running} test={test} />
      )}
      {queued.length > 0 && (
        <p className="text-muted small">
          Next: {queued[0].hostname || queued[0].host}, waiting for a free
          worker
        </p>
      )}
    </FormSection>
  );
}

function title(running: number, queued: number) {
  const counts = [
    running > 0 && `${running} running`,
    queued > 0 && `${queued} queued`,
  ].filter(Boolean);
  return `In progress: ${counts.join(', ')}`;
}
